import {
  CLAIM_PANEL_MIN_WIDTH, CLAIM_PANEL_MAX_WIDTH, CLAIM_PANEL_DEFAULTS,
} from "../../../services/claimPanelPreferences.js";

// The existing 158px navigation rail plus its margin, a 16px panel gap, and
// enough usable content space for forms. Wider tables retain their own scroll.
const RAIL_AND_GAP = 158 + 16 + 16;
const MIN_CONTENT_WIDTH = 640;

export function claimPanelLayout(availableWidth, preferredWidth = CLAIM_PANEL_DEFAULTS.width) {
  const maxWidth = Math.min(CLAIM_PANEL_MAX_WIDTH, Math.floor(availableWidth - RAIL_AND_GAP - MIN_CONTENT_WIDTH));
  const canDock = maxWidth >= CLAIM_PANEL_MIN_WIDTH;
  return {
    canDock,
    maxWidth: Math.max(CLAIM_PANEL_MIN_WIDTH, maxWidth),
    width: Math.max(CLAIM_PANEL_MIN_WIDTH, Math.min(preferredWidth, Math.max(CLAIM_PANEL_MIN_WIDTH, maxWidth))),
  };
}
